<template>
  <institution-picker-dialog :employee="employee" :value="value" mode="assign" @input="$emit('input', $event)" @update:employee="$emit('update:employee')"/>
</template>

<script lang="ts">
import Vue from 'vue';
import {Employee} from '@/interfaces/employee.interface';
import InstitutionPickerDialog from './institutionPicker/institutionPickerDialog.vue';

/** Standorte zuteilen for a teacher / applicant with ranked suggestions (application choice, availability, air-line distance, demand); saving lives in institutionPickerDialog */
export default Vue.extend({
  components: {InstitutionPickerDialog},
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object as () => Employee,
      required: true,
    },
  },
});
</script>
